module.exports = __webpack_public_path__ + "static/media/icon_ritsubb91761fe5e7ce8819893b042b81a497.webp";